// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".6576992b3b777d6cb1dbb5dd8387c663.js";
};